<template>
  <svg
    fill="#000000"
    version="1.1"
    id="Capa_1"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    class="size-6"
    viewBox="0 0 135.938 135.938"
    xml:space="preserve"
  >
    <g>
      <g>
        <path
          d="M59.333,0c-1.937,0-3.504,1.567-3.504,3.504v26.062h-4.411V3.504C51.417,1.567,49.852,0,47.913,0
			s-3.504,1.567-3.504,3.504v26.062h-4.411V3.504C39.998,1.567,38.43,0,36.493,0c-1.938,0-3.504,1.567-3.504,3.504V33.07
			c0,1.939,1.565,3.504,3.504,3.504h7.916v95.857c0,1.94,1.566,3.504,3.504,3.504s3.504-1.563,3.504-3.504v-95.86h7.916
			c1.938,0,3.504-1.565,3.504-3.504V3.501C62.837,1.567,61.271,0,59.333,0z"
        />
        <path
          d="M100.618,0.204c-1.39-0.498-2.953-0.063-3.888,1.093C74.216,28.953,81.645,67.061,81.974,68.669
			c0.335,1.632,1.766,2.806,3.432,2.806H95.94v60.959c0,1.94,1.563,3.504,3.504,3.504c1.938,0,3.505-1.563,3.505-3.504V3.511
			C102.949,2.022,102.014,0.698,100.618,0.204z M95.94,64.458h-7.539c-1.026-7.705-2.759-29.897,7.539-49.327V64.458z"
        />
      </g>
    </g>
  </svg>
</template>
